import React from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { TimeManagementListItem as TimeManagementListItemType } from "@myapp/contract";
import Loader from "../../../../shared/ui/feedback/Loader/Loader";
import { TimeManagementListItem } from "./TimeManagementListItem";

interface TimeManagementListViewProps {
  items: TimeManagementListItemType[];
  isLoading: boolean;
  isFetchingNextPage: boolean;
  hasMore: boolean;
  onLoadMore: () => void;
}

export const TimeManagementListView: React.FC<TimeManagementListViewProps> = ({
  items,
  isLoading,
  isFetchingNextPage,
  hasMore,
  onLoadMore,
}) => {
  if (isLoading && !items.length) {
    return (
      <div className="my-10 flex w-full justify-center">
        <Loader />
      </div>
    );
  }

  if (!items.length) {
    return (
      <p className="my-10 w-full text-center font-['PT_Sans'] text-[20px] font-bold text-primary">
        Keine Einträge für die aktuellen Filter.
      </p>
    );
  }

  return (
    <InfiniteScroll
      dataLength={items.length}
      next={onLoadMore}
      hasMore={hasMore}
      loader={
        <div className="my-4 flex w-full justify-center">
          <Loader size="small" />
        </div>
      }
      scrollableTarget="scrollableDiv"
      style={{ overflow: "visible" }}
    >
      <div className="flex w-full flex-col gap-4">
        {items.map((item) => (
          <TimeManagementListItem key={item.id} item={item} />
        ))}
      </div>

      {isFetchingNextPage && (
        <div className="my-4 flex w-full justify-center">
          <Loader size="small" />
        </div>
      )}
    </InfiniteScroll>
  );
};
